import * as actions from "./actionsTypes";

const initialData = {
  loaderArea: false,
  loaderAreas: false,
  saveLoaderArea: false,
  areas: null,
  areasDesc: null,
  area: null,
  areasFaild: null,
  areaFaild: null,
  formAreaFaild: null,
};

export default function competenciesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_AREA:
      return { ...state, loaderArea: action.payload };
    case actions.LOADER_AREAS:
      return { ...state, loaderAreas: action.payload };
    case actions.LOADER_AREAS_DESC:
      return { ...state, loaderAreas: action.payload };
    case actions.SAVE_LOADER_AREA:
      return { ...state, saveLoaderArea: action.payload };
    case actions.GET_AREA:
      return { ...state, area: action.payload };
    case actions.GET_AREAS:
      return { ...state, areas: action.payload };
    case actions.GET_AREAS_DESC:
      return { ...state, areasDesc: action.payload };
    case actions.AREA_FAIL:
      return { ...state, areaFaild: action.payload };
    case actions.AREAS_FAIL:
      return { ...state, areasFaild: action.payload };
    case actions.FORM_AREA_FAIL:
      return { ...state, formAreaFaild: action.payload };
    default:
      return state;
  }
}
